import { IconButton } from '@/shared/ui/icon-button'

interface CallToolbarProps {
  micOn: boolean
  camOn: boolean
  screenOn: boolean
  onToggleMic: () => void
  onToggleCam: () => void
  onToggleScreen: () => void
  onLeave: () => void
  onSwitchCamera?: () => void
  onBackground?: () => void
  onToggleSidebar?: () => void
  sidebarOn?: boolean
  onEnd?: () => void
}

export function CallToolbar({
  micOn,
  camOn,
  screenOn,
  onToggleMic,
  onToggleCam,
  onToggleScreen,
  onLeave,
  onSwitchCamera,
  onBackground,
  onToggleSidebar,
  sidebarOn = false,
  onEnd,
}: CallToolbarProps) {
  return (
    <div
      role="toolbar"
      aria-label="Управление звонком"
      className="flex max-w-full items-center justify-center gap-1.5 rounded-pill border border-border-default bg-bg-elevated px-2 py-1.5 sm:gap-3 sm:px-4 sm:py-3"
    >
      <IconButton
        icon={micOn ? 'mic' : 'mic-off'}
        label={micOn ? 'Выключить микрофон' : 'Включить микрофон'}
        active={!micOn}
        tone="danger"
        onClick={onToggleMic}
      />
      <IconButton
        icon={camOn ? 'camera' : 'camera-off'}
        label={camOn ? 'Выключить камеру' : 'Включить камеру'}
        active={!camOn}
        tone="danger"
        onClick={onToggleCam}
      />
      {/* Flip фронт/тыл — телефонный контрол, десктопу не нужен: до sm. */}
      {onSwitchCamera && camOn && (
        <span className="sm:hidden">
          <IconButton icon="camera-flip" label="Сменить камеру" onClick={onSwitchCamera} />
        </span>
      )}
      {/* Мобильные браузеры не отдают getDisplayMedia — контрол только с sm.
          Обёртка, а не class на кнопке: базовый inline-flex кнопки в CSS-порядке
          Tailwind перебивает hidden. */}
      <span className="hidden sm:block">
        <IconButton
          icon="screen-share"
          label={screenOn ? 'Остановить демонстрацию' : 'Демонстрация экрана'}
          active={screenOn}
          onClick={onToggleScreen}
        />
      </span>
      {onBackground && <IconButton icon="settings" label="Настройки" onClick={onBackground} />}
      {onToggleSidebar && (
        <IconButton
          icon="users"
          label="Участники и чат"
          active={sidebarOn}
          onClick={onToggleSidebar}
        />
      )}
      {onEnd && (
        <IconButton icon="close" label="Завершить для всех" tone="danger" onClick={onEnd} />
      )}
      <IconButton icon="leave" label="Покинуть звонок" tone="danger" active onClick={onLeave} />
    </div>
  )
}
